enum TicketSeverityType {
  NOT_ASSIGNED = 'Not Assigned',
  HIGH = 'Major',
  MEDIUM = 'Moderate',
  LOW = 'Minor',
}

export default TicketSeverityType;
